const filterPopUp = {
    init() {
        
        let popUpNode = document.querySelector('.js-filter-popup');

        if(! popUpNode) {
            return;
        }

        window.initPackage('https://cdnjs.cloudflare.com/ajax/libs/gsap/3.11.4/gsap.min.js').then(function() {
            popUpNode.dataset.initialized = "true";
        })
        .catch(function(error) {
            console.error(error);
        });
    },

    openPopUp() {
        let popUpNode = document.querySelector('.js-filter-popup');

        if(!popUpNode.dataset.initialized) {
            return;
        }

        popUpNode.classList.remove('hidden');
        gsap.from(popUpNode, {autoAlpha: 0, duration: 0.3});
        gsap.from(popUpNode.querySelector('div'), {autoAlpha: 0, duration: 0.3, y: -50});
    },

    closePopUp() {
        let popUpNode = document.querySelector('.js-filter-popup');

        if(!popUpNode.dataset.initialized) {
            return;
        }
        
        gsap.to(popUpNode, {autoAlpha: 0, duration: 0.3, delay: 0.1, onComplete:function(){
            popUpNode.removeAttribute('style');
            popUpNode.classList.add('hidden');
        }});
    }
};

window.filterPopUp = filterPopUp;

filterPopUp.init();

document.addEventListener('LokiRequestEnd', function () {
    filterPopUp.init();
});
